import * as actions from "./actions";
import produce from "immer";
import {
  GDPR_DEACTIVATE_ERROR,
  GDPR_DEACTIVATE_REQUEST,
  GDPR_DEACTIVATE_SUCCESS,
  GDPR_REMOVE_BORROWER_ERROR,
  GDPR_REMOVE_BORROWER_REQUEST,
  GDPR_REMOVE_BORROWER_SUCCESS,
  GDPR_REMOVE_ERROR,
  GDPR_REMOVE_REQUEST,
  GDPR_REMOVE_SUCCESS,
  MANUALLY_MARK_AS_IDENTIFIED_ERROR,
  MANUALLY_MARK_AS_IDENTIFIED_REQUEST,
  MANUALLY_MARK_AS_IDENTIFIED_SUCCESS,
  SALESREP_GET_ERROR,
  SALESREP_GET_REQUEST,
  SALESREP_GET_SUCCESS,
} from "./actions";

let initialState = {
  availableBankAccounts: {
    fetching: false,
    fetched: false,
    data: [],
  },
  gdprCloseBorrower: {
    sent: false,
    sending: false,
    error: null,
  },
  gdprDeactivateInvestor: {
    sent: false,
    sending: false,
    error: null,
  },
  gdprCloseInvestor: {
    sent: false,
    sending: false,
    error: null,
  },
  markPersonAsIdentified: {
    sending: false,
    sent: false,
    error: null,
  },
  salesRepresentatives: {
    fetching: false,
    fetched: false,
    data: undefined,
    error: null,
  },
};

const system = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case actions.GET_BANKS_REQUEST:
        draft.availableBankAccounts.fetching = true;
        draft.availableBankAccounts.fetched = false;
        break;
      case actions.GET_BANKS_SUCCESS: {
        draft.availableBankAccounts.fetching = false;
        draft.availableBankAccounts.fetched = true;
        draft.availableBankAccounts.data = action.response;
        break;
      }
      case GDPR_REMOVE_BORROWER_REQUEST:
        draft.gdprCloseBorrower.sending = true;
        draft.gdprCloseBorrower.sent = false;
        draft.gdprCloseBorrower.error = null;
        break;
      case GDPR_REMOVE_BORROWER_SUCCESS:
        draft.gdprCloseBorrower.sending = false;
        draft.gdprCloseBorrower.sent = true;
        draft.gdprCloseBorrower.error = null;
        break;
      case GDPR_REMOVE_BORROWER_ERROR:
        draft.gdprCloseBorrower.sending = false;
        draft.gdprCloseBorrower.sent = false;
        draft.gdprCloseBorrower.error = action.error;
        break;
      case GDPR_REMOVE_REQUEST:
        draft.gdprCloseInvestor.sending = true;
        draft.gdprCloseInvestor.sent = false;
        draft.gdprCloseInvestor.error = null;
        break;
      case GDPR_REMOVE_SUCCESS:
        draft.gdprCloseInvestor.sending = false;
        draft.gdprCloseInvestor.sent = true;
        draft.gdprCloseInvestor.error = null;
        break;
      case GDPR_REMOVE_ERROR:
        draft.gdprCloseInvestor.sending = false;
        draft.gdprCloseInvestor.sent = false;
        draft.gdprCloseInvestor.error = action.error;
        break;
      case GDPR_DEACTIVATE_REQUEST:
        draft.gdprDeactivateInvestor.sending = true;
        draft.gdprDeactivateInvestor.sent = false;
        draft.gdprDeactivateInvestor.error = null;
        break;
      case GDPR_DEACTIVATE_SUCCESS:
        draft.gdprDeactivateInvestor.sending = false;
        draft.gdprDeactivateInvestor.sent = true;
        draft.gdprDeactivateInvestor.error = null;
        break;
      case GDPR_DEACTIVATE_ERROR:
        draft.gdprDeactivateInvestor.sending = false;
        draft.gdprDeactivateInvestor.sent = false;
        draft.gdprDeactivateInvestor.error = action.error;
        break;
      case MANUALLY_MARK_AS_IDENTIFIED_REQUEST: {
        draft.markPersonAsIdentified.sending = true;
        draft.markPersonAsIdentified.sent = false;
        draft.markPersonAsIdentified.error = null;
        break;
      }
      case MANUALLY_MARK_AS_IDENTIFIED_ERROR: {
        draft.markPersonAsIdentified.sending = false;
        draft.markPersonAsIdentified.sent = false;
        draft.markPersonAsIdentified.error = action.error;
        break;
      }
      case MANUALLY_MARK_AS_IDENTIFIED_SUCCESS: {
        draft.markPersonAsIdentified.sending = false;
        draft.markPersonAsIdentified.sent = true;
        draft.markPersonAsIdentified.error = null;
        break;
      }
      case SALESREP_GET_REQUEST: {
        draft.salesRepresentatives.fetching = true;
        draft.salesRepresentatives.fetched = false;
        draft.salesRepresentatives.error = null;
        break;
      }
      case SALESREP_GET_ERROR: {
        draft.salesRepresentatives.fetching = false;
        draft.salesRepresentatives.fetched = false;
        draft.salesRepresentatives.error = action.error;
        break;
      }
      case SALESREP_GET_SUCCESS: {
        draft.salesRepresentatives.fetching = false;
        draft.salesRepresentatives.fetched = true;
        draft.salesRepresentatives.data = action.response;
        draft.salesRepresentatives.error = null;
        break;
      }
      default:
        return draft;
    }
  });
};

export default system;
